import { Component } from '@angular/core';
import { RadioWidget as _RadioWidget } from '../angular2-schema-form-shim';
import { JSONSchema } from '../types/json-schema';
import { isWidgetRequired } from './overrides';

export type RadioOptionValue = string | number;

export type RadioOption = {
  value: RadioOptionValue;
  label: string;
};

@Component( {
  selector: 'sp-radio-widget',
  templateUrl: './radio.widget.html',
} )
export class RadioWidget extends _RadioWidget {
  schema: JSONSchema;
  options: Array<RadioOption> = [];

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.setupOptions();
  }

  setupOptions() {
    this.options = this.schema.enum.map( ( value, index ) => ( {
      value: value,
      label: this.schema.options.enum_titles[ index ],
    } ) );
  }

  get required() {
    return isWidgetRequired( this );
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/radio.widget.ts